/**
 * Значения окружения, зашитые в бандл на этапе сборки.
 *
 * Секретов здесь нет и быть не может: всё, что попадает в `import.meta.env`, видно любому,
 * кто откроет исходники страницы. У панели и нет ничего секретного — она клиент API (AD-A1).
 */
export const env = {
  // Запасное значение — для `npm run dev` и тестов. Сборка без переменной падает:
  // `scripts/check-env.mjs` требует всё, что читает код.
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3000',
  isDev: import.meta.env.DEV,
  // Контракт, под который собрано приложение (AD-A2). Тег без дайджеста ничего не доказывает:
  // нерелизная ветка бэкенда объявляет ту же `info.version`. Оба значения запекает
  // `vite.config.ts` из закрепления, сошедшегося с файлом контракта.
  contract: {
    tag: import.meta.env.VITE_CONTRACT_TAG ?? '',
    sha256: import.meta.env.VITE_CONTRACT_SHA256 ?? '',
  },
} as const;
